<fieldset class="form">
  <div class="form-group">
    <ng-template #rt let-r="result" let-t="term">
      <strong>
        <ngb-highlight [result]="r.Id_Comercial" [term]="t"></ngb-highlight>
      </strong>
      - <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
    </ng-template>
    
    <label for="typeahead-http">Operador<span class="text-danger">*</span></label>

    <input
      id="typeahead-http"
      type="text"
      class="form-control"
      [class.is-invalid]="searchFailed"
      [(ngModel)]="model"
      [ngbTypeahead]="search"
      placeholder="Buscar operador"
      [resultTemplate]="rt"
      [inputFormatter]="formatter"
    />
    <small *ngIf="searching" class="form-text text-muted">Buscando...</small>
    <div class="invalid-feedback" *ngIf="searchFailed">
      Lo sentimos, las sugerencias no se pudieron cargar.
    </div>
  </div>
</fieldset>
<!-- <pre>Model: {{ model | json }}</pre> -->
